import { MessageType } from "../types/messageType";

export const getLastMessage = (id: number, messages: MessageType[]) => {
  const data = messages.filter((item) => {
    return item.receiverId === `${id}` && item.senderId === "1";
  });
  if (data.length !== 0) {
    return data[data.length - 1].message.text;
  } else {
    return null;
  }
};
